<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('admin.list_manager.upload_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="admin-list-manager-import-submit"
                :loading="processing"
                :disabled="fileList.length == 0"
                @click="handleSubmit"
            >
                {{ $t('admin.list_manager.upload_modal.submit') }}
            </a-button>
        </template>
        <a-upload-dragger
            name="file"
            data-cy="admin-list-manager-import-drag"
            @remove="handleRemove"
            :file-list="fileList"
            :multiple="true"
            :before-upload="beforeUpload"
        >
            <p class="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p class="ant-upload-text">{{ $t('admin.list_manager.upload_modal.body') }}</p>
            <p class="ant-upload-hint">{{ $t('admin.list_manager.upload_modal.hint') }}</p>
        </a-upload-dragger>
    </a-modal>
</template>

<script>
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
    components: { InboxOutlined },
    data() {
        return {
            modal_visible: false,
            fileList: [],
            fileLimit: -3,
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        handleSubmit() {
            const { fileList } = this;
            const formData = new FormData();
            fileList.forEach((file) => {
                formData.append('files[]', file);
            });
            this.processing = true;
            this.$emit('formSubmit', formData);
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            const isCSV = file.type === 'text/csv';
            if (isCSV) {
                if (this.fileList.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.fileList = [...this.fileList, file].slice(this.fileLimit);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'CSV' }),
                });
            }
            return false;
        },
    },
};
</script>
